import React, { memo } from 'react';
import { Grid } from '@mui/material';

import { processFlights } from './processFlights';

import ItineraryFlightCard from './ItineraryFlightCard';
import ItineraryWaitCard from './ItineraryWaitCard';

const FlightItineraryDetail = ({ flights = [], id_option, idPrefix }) => {
  const refactorData = processFlights(flights);

  return (
    <Grid sx={{ width: '100%' }}>
      {refactorData.map((info, idx) =>
        info.type === 'flight' ? (
          <ItineraryFlightCard
            key={`detail-${id_option}-${info.data.flight_number}-${idx}`}
            idPrefix={idPrefix && `${idPrefix}-tramo${idx + 1}`}
            flight={info.data}
            id_option={id_option}
          />
        ) : (
          <ItineraryWaitCard
            key={`wait-${id_option}-${info.data.flight_number}-${idx}`}
            info={info}
            id_option={id_option}
            flight={info.data}
          />
        )
      )}
    </Grid>
  );
};

export default memo(FlightItineraryDetail);
